import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL } from "@/utils/http-common"
import _ from "lodash"

const get = function ($, projectId, pcsDsiId = null) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${pcsDsiId ? "pcq-dsis/" + pcsDsiId : projectId + "/pcq-dsis"}`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

// const getAllPcqDsi = function () {
//   return new Promise((resolve, reject) => {
//     HTTP.get(`/projects/pcq-dsis`)
//       .then(response => resolve(response.data))
//       .catch(err => {
//         return reject(err)
//       })
//   })
// }

const getByTask = function (projectId, taskId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${projectId}/tasks/${taskId}/pcq-dsis`)
      .then(response => {
        resolve(response.data)
      })
      .catch(exception => {
        reject(exception)
      })
  })
}

const createWithTask = function ($, projectId, taskId, pcsDsi) {
  if (_.isObject(pcsDsi.task)) {
    pcsDsi.task = pcsDsi.task.pk
  }

  return new Promise((resolve, reject) => {
    HTTP.post(`projects/${projectId}/tasks/${taskId}/pcq-dsis`, pcsDsi)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const create = function ($, projectId, pcsDsi) {
  return new Promise((resolve, reject) => {
    HTTP.post(`projects/${projectId}/no-tasks/pcq-dsis`, pcsDsi)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const validate = function ($, projectId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`projects/${projectId}/validate/pcq-dsis`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const update = function ($, pcsDsiId, data) {
  if (_.isObject(data.task)) data.task = data.task.id
  return new Promise((resolve, reject) => {
    HTTP.patch(`/projects/pcq-dsis/${pcsDsiId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, pcsDsiId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/projects/pcq-dsis/${pcsDsiId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const wordExport = function ($, projectId) {
  return new Promise((resolve, reject) => {
    const url = `${BACKEND_API_URL}/projects/${projectId}/word-download/pcq-dsis`
    // const url = HTTP.get(`/projects/${projectId}/word-download/pcq-dsis`)

    // Prepare request
    let xhr = new XMLHttpRequest()
    xhr.open("GET", url, true)
    xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
    xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
    xhr.responseType = "blob"
    xhr.onload = function () {
      if (xhr.status === 200) resolve(xhr.response)
      else reject(xhr)
    }

    // Execute request
    xhr.send()
  })
}

const getAllActions = function (pcqId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/pcq-dsis/${pcqId}/action`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createAction = function (pcqId, data) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/pcq-dsis/${pcqId}/action`, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getPcqDsi = function (pcqId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/pcq-dsis/${pcqId}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getPublicPcqDsi = function (pcqId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/pcq-dsis/public/${pcqId}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const sign = function (pcqDsiId, section, signatureImage) {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append("section", section)
    formData.append("signature_image", signatureImage)

    HTTP.post(`/projects/pcq-dsis/${pcqDsiId}/sign`, formData)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const signExternal = function (pcqDsiId, uuid, signatureImage, { firstName, lastName }) {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append("external_code", uuid)
    formData.append("signature_image", signatureImage)
    formData.append("first_name", firstName)
    formData.append("last_name", lastName)

    HTTP.post(`/projects/pcq-dsis/public/${pcqDsiId}/sign`, formData)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default {
  get,
  getAllActions,
  getPcqDsi,
  getPublicPcqDsi,
  getByTask,
  create,
  update,
  remove,
  close,
  createWithTask,
  wordExport,
  validate,
  createAction,
  sign,
  signExternal
}
